export const Document = () => {
  return (
    <svg viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 1H2.5C2.10218 1 1.72064 1.16857 1.43934 1.46863C1.15804 1.76869 1 2.17565 1 2.6V15.4C1 15.8243 1.15804 16.2313 1.43934 16.5314C1.72064 16.8314 2.10218 17 2.5 17H11.5C11.8978 17 12.2794 16.8314 12.5607 16.5314C12.842 16.2313 13 15.8243 13 15.4V5L9 1Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 1V5H13"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
